import { render, staticRenderFns } from "./AmountInfo.vue?vue&type=template&id=1fffe109&scoped=true"
import script from "./AmountInfo.vue?vue&type=script&lang=js"
export * from "./AmountInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fffe109",
  null
  
)

export default component.exports